import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default () => {
  const locales = useSelector((state: any) => state.common.locales);
  const registerPageLocales = useSelector(
    (state: any) => state.common.config?.registrationLocales
  );

  const localesOptions: { label: string; value: string }[] = useMemo(() => {
    if (!registerPageLocales || !locales) {
      return [];
    }
    return registerPageLocales.map((localeCode: string) => {
      const locale = locales.find((loc: any) => loc.code === localeCode);
      return { label: locale.displayName, value: locale.code };
    });
  }, [registerPageLocales, locales]);

  return localesOptions;
};
